import React from 'react';
import {Tag} from 'antd';
import utils from '../../../utils';
import fetch from '../../fetch';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns([
    {
        key:'$index', 
        label: '序号',
        width: 80
    },
    {
        key: 'orgName',
        label: '部门名称',
        width: 220
    },
    {
        key: 'statusDesc',
        label: '填写状态',
        render : (val)=> {
            if(val == '已填写'){
                return <Tag color='green'>{val}</Tag>
            }else if(val == '未填写'){
                return <Tag color='red'>{val}</Tag>
            }
        },
    },
    {
        key: 'num1',
        label: <div className='survey-table-title'>全日制2021级、2022级学生总数</div>,
        width: 150
    },
    {
        key: 'num2',
        label: '23届毕业生总数',
        width: 150
    },
    {
        key: 'num2Other',
        label: <div className='survey-table-title'>22、21、20三届毕业生总数</div>,
        width: 150
    },
    {
        key: 'num3',
        label: '教职员工总数',
        width: 150
    },
    {
        key: 'num4',
        label: <div className='survey-table-title'>录用2023年应届全日制毕业生的单位或部门总数</div>,
        width: 150
    },
    {
        key: 'num5',
        label:  <div className='survey-table-title'>全日制在校生和2023年应届毕业生家长总数</div>,
        width: 150
    },
    {
        key: 'termName',
        label: '学期',
        width: 150
    },
])

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('survey/statistics/query2?' + params.join('&'), keywords)
    .then((response) => {
        if(response.code === 200) {
            return response.payload.data;
        }
    }).then(data => (
        Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data || []).length ? '' : '暂无数据...'
        }))
    )
}

export default {
    setRefresh,
    onSelect,
    getSelection,
    columns,
    querySearch
}